module.exports = __webpack_public_path__ + "img/borussia-dortmund-logo-icon.786bc398.png";